export default "https://cdn.questicon.mathletics.com/assets/images/Smiling Face with Smiling Eyes-9227c8b9d7e7f4924ca0a544bdd3a8bd.svg";